import { render, staticRenderFns } from "./cardVR.vue?vue&type=template&id=e084c1c2"
import script from "./cardVR.vue?vue&type=script&lang=js"
export * from "./cardVR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports